import React, { useState, useEffect } from 'react';

const ContemporaryHomepage = () => {
  const [featuredPosts, setFeaturedPosts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Mock data - replace with actual Ghost API call
    const mockPosts = [
      {
        id: '1',
        title: 'Sangue de Todas as Cores',
        excerpt: 'A contemporary exploration of identity and belonging through theatrical performance.',
        featureImage: 'https://picsum.photos/1200/800?random=20',
        url: '#',
        publishedAt: '2024-11-01',
        tags: ['Performance', 'Theater']
      },
      {
        id: '2',
        title: 'História do Coco',
        excerpt: 'An immersive journey into cultural narratives and collective memory.',
        featureImage: 'https://picsum.photos/1200/800?random=21',
        url: '#',
        publishedAt: '2024-10-28',
        tags: ['Exhibition', 'Art']
      },
      {
        id: '3',
        title: 'O Jardim das Cerejeiras',
        excerpt: 'Reimagining classic narratives through contemporary lens and minimal aesthetic.',
        featureImage: 'https://picsum.photos/1200/800?random=22',
        url: '#',
        publishedAt: '2024-10-20',
        tags: ['Theater', 'Contemporary']
      }
    ];

    setTimeout(() => {
      setFeaturedPosts(mockPosts);
      setLoading(false);
    }, 600);
  }, []);

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric'
    });
  };

  return (
    <div className="contemporary-homepage">
      <style>{`
        .contemporary-homepage {
          font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Helvetica Neue', Arial, sans-serif;
            color: var(--text-primary);
          padding-top: 80px;
        }

        /* Hero Section */
        .contemporary-hero {
          max-width: 1400px;
          margin: 0 auto;
          padding: clamp(4rem, 10vw, 8rem) clamp(1.5rem, 4vw, 3rem);
          min-height: 60vh;
          display: flex;
          align-items: center;
        }

        .contemporary-hero-content {
          max-width: 800px;
        }

        .contemporary-hero-title {
          font-size: clamp(3rem, 8vw, 6rem);
          font-weight: 600;
          line-height: 1.1;
          letter-spacing: -0.03em;
          margin: 0 0 2rem 0;
           color: var(--text-primary);
        }

        .contemporary-hero-subtitle {
          font-size: clamp(1.125rem, 2vw, 1.5rem);
          font-weight: 400;
          line-height: 1.6;
            color: var(--text-secondary);
          margin: 0 0 3rem 0;
          max-width: 600px;
        }

        .contemporary-hero-cta {
          display: inline-flex;
          align-items: center;
          gap: 0.75rem;
          padding: 1rem 2rem;
          background: rgba(17, 24, 39, 0.95);
          color: #fff;
          text-decoration: none;
          font-size: 0.9375rem;
          font-weight: 500;
          letter-spacing: 0.01em;
          border-radius: 2px;
          transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
        }

        .contemporary-hero-cta:hover {
          background: rgba(17, 24, 39, 0.9);
          transform: translateY(-2px);
          box-shadow: 0 4px 12px rgba(17, 24, 39, 0.12);
        }

        /* Featured Grid */
        .contemporary-section {
          max-width: 1400px;
          margin: 0 auto;
          padding: clamp(3rem, 8vw, 6rem) clamp(1.5rem, 4vw, 3rem);
        }

        .contemporary-section-header {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: clamp(2rem, 5vw, 4rem);
          padding-bottom: 1.5rem;
           border-bottom: 1px solid rgba(17, 24, 39, 0.08);
        }

        .contemporary-section-title {
          font-size: clamp(1.75rem, 3vw, 2.5rem);
          font-weight: 600;
          letter-spacing: -0.02em;
          margin: 0;
           color: var(--text-primary);
        }

        .contemporary-section-link {
          font-size: 0.9375rem;
          font-weight: 500;
            color: var(--text-secondary);
          text-decoration: none;
          transition: color 0.2s ease;
          letter-spacing: 0.01em;
        }

        .contemporary-section-link:hover {
           color: var(--text-primary);
        }

        .contemporary-grid {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(350px, 1fr));
          gap: clamp(2rem, 4vw, 3rem);
        }

        /* Post Card */
        .contemporary-card {
          display: block;
          text-decoration: none;
            color: var(--text-primary);
          transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);
        }

        .contemporary-card:hover {
          transform: translateY(-4px);
        }

        .contemporary-card:hover .contemporary-card-image img {
          transform: scale(1.03);
        }

        .contemporary-card-image {
          aspect-ratio: 4/3;
          background: rgba(17, 24, 39, 0.04);
          border-radius: 2px;
          overflow: hidden;
          margin-bottom: 1.5rem;
        }

        .contemporary-card-image img {
          width: 100%;
          height: 100%;
          object-fit: cover;
          transition: transform 0.6s cubic-bezier(0.4, 0, 0.2, 1);
        }

        .contemporary-card-meta {
          display: flex;
          align-items: center;
          gap: 1rem;
          margin-bottom: 0.75rem;
          font-size: 0.8125rem;
          color: rgba(17, 24, 39, 0.5);
          letter-spacing: 0.03em;
          text-transform: uppercase;
        }

        .contemporary-card-tag {
          font-weight: 500;
        }

        .contemporary-card-date {
          position: relative;
          padding-left: 1rem;
        }

        .contemporary-card-date::before {
          content: '';
          position: absolute;
          left: 0;
          top: 50%;
          transform: translateY(-50%);
          width: 3px;
          height: 3px;
          background: rgba(17, 24, 39, 0.3);
          border-radius: 50%;
        }

        .contemporary-card-title {
          font-size: clamp(1.25rem, 2.5vw, 1.75rem);
          font-weight: 600;
          line-height: 1.3;
          letter-spacing: -0.02em;
          margin: 0 0 0.75rem 0;
        }

        .contemporary-card-excerpt {
          font-size: 1rem;
          line-height: 1.6;
            color: var(--text-secondary);
          margin: 0;
        }

        /* Loading State */
        .contemporary-loading {
          display: flex;
          justify-content: center;
          align-items: center;
          min-height: 400px;
        }

        .contemporary-spinner {
          width: 40px;
          height: 40px;
          border: 2px solid rgba(17, 24, 39, 0.1);
          border-top-color: var(--text-primary);
          border-radius: 50%;
          animation: spin 0.8s linear infinite;
        }

        @keyframes spin {
          to { transform: rotate(360deg); }
        }

        /* Newsletter Section */
        .contemporary-newsletter {
          background: rgba(17, 24, 39, 0.02);
          padding: clamp(3rem, 8vw, 5rem) clamp(1.5rem, 4vw, 3rem);
          margin-top: clamp(4rem, 10vw, 8rem);
          text-align: center;
        }

        .contemporary-newsletter-inner {
          max-width: 600px;
          margin: 0 auto;
        }

        .contemporary-newsletter-title {
          font-size: clamp(1.75rem, 3vw, 2.5rem);
          font-weight: 600;
          letter-spacing: -0.02em;
          margin: 0 0 1rem 0;
           color: var(--text-primary);
        }

        .contemporary-newsletter-text {
          font-size: 1.0625rem;
          line-height: 1.6;
            color: var(--text-secondary);
          margin: 0 0 2rem 0;
        }

        .contemporary-newsletter-form {
          display: flex;
          gap: 0.75rem;
          max-width: 500px;
          margin: 0 auto;
        }

        .contemporary-newsletter-input {
          flex: 1;
          padding: 1rem 1.25rem;
          border: 1px solid rgba(17, 24, 39, 0.12);
          border-radius: 2px;
          font-size: 0.9375rem;
          background: #fff;
          transition: border-color 0.2s ease;
        }

        .contemporary-newsletter-input:focus {
          outline: none;
           border-color: var(--text-primary);
        }

        .contemporary-newsletter-submit {
          padding: 1rem 2rem;
            background: var(--text-primary);
          color: #fff;
          border: none;
          border-radius: 2px;
          font-size: 0.9375rem;
          font-weight: 500;
          cursor: pointer;
          transition: all 0.3s ease;
          white-space: nowrap;
        }

        .contemporary-newsletter-submit:hover {
           background: rgba(17, 24, 39, 0.85);
          transform: translateY(-2px);
          box-shadow: 0 4px 12px rgba(17, 24, 39, 0.15);
        }

        /* Responsive */
        @media (max-width: 768px) {
          .contemporary-homepage {
            padding-top: 72px;
          }

          .contemporary-grid {
            grid-template-columns: 1fr;
            gap: 2.5rem;
          }

          .contemporary-newsletter-form {
            flex-direction: column;
          }

          .contemporary-section-header {
            flex-direction: column;
            align-items: flex-start;
            gap: 1rem;
          }
        }

        @media (max-width: 640px) {
          .contemporary-homepage {
            padding-top: 64px;
          }
        }
      `}</style>

      {/* Hero Section */}
      <section className="contemporary-hero">
        <div className="contemporary-hero-content">
          <h1 className="contemporary-hero-title">
            Contemporary Theater & Art
          </h1>
          <p className="contemporary-hero-subtitle">
            Exploring the boundaries of performance, visual art, and cultural dialogue through innovative theatrical experiences.
          </p>
          <a href="/shows/" className="contemporary-hero-cta">
            View Current Productions
          </a>
        </div>
      </section>

      {/* Featured Posts */}
      <section className="contemporary-section">
        <div className="contemporary-section-header">
          <h2 className="contemporary-section-title">Latest Work</h2>
          <a href="/archive/" className="contemporary-section-link">View All</a>
        </div>

        {loading ? (
          <div className="contemporary-loading">
            <div className="contemporary-spinner"></div>
          </div>
        ) : (
          <div className="contemporary-grid">
            {featuredPosts.map((post) => (
              <a key={post.id} href={post.url} className="contemporary-card">
                <div className="contemporary-card-image">
                  <img src={post.featureImage} alt={post.title} loading="lazy" />
                </div>
                <div className="contemporary-card-meta">
                  <span className="contemporary-card-tag">{post.tags[0]}</span>
                  <time className="contemporary-card-date">
                    {formatDate(post.publishedAt)}
                  </time>
                </div>
                <h3 className="contemporary-card-title">{post.title}</h3>
                <p className="contemporary-card-excerpt">{post.excerpt}</p>
              </a>
            ))}
          </div>
        )}
      </section>

      {/* Newsletter */}
      <section className="contemporary-newsletter">
        <div className="contemporary-newsletter-inner">
          <h2 className="contemporary-newsletter-title">Stay Connected</h2>
          <p className="contemporary-newsletter-text">
            Subscribe to receive updates on upcoming performances, exhibitions, and cultural events.
          </p>
          <form className="contemporary-newsletter-form" onSubmit={(e) => e.preventDefault()}>
            <input
              type="email"
              className="contemporary-newsletter-input"
              placeholder="Enter your email"
              required
            />
            <button type="submit" className="contemporary-newsletter-submit">
              Subscribe
            </button>
          </form>
        </div>
      </section>
    </div>
  );
};

export default ContemporaryHomepage;
